import "./MainPage.scss";
import RandomPackages from "../../Components/RandomPackages/RandomPackagesWrapper";
import LandingHomePage from "./landing/LandingHomePage";

function Main() {
  return (
    <div className="main-page main-page--v2">
      {/* הצ'אט הצף מורכב גלובלית דרך HotelsRiverChatGate ב-Routes.jsx */}
      <LandingHomePage />
      <section
        className="home-section home-section--packages"
        aria-labelledby="home-featured-packages-title"
      >
        <div className="home-page__container">
          <h2 className="hr-landing-packages-heading" id="home-featured-packages-title">
            חבילות מהמערכת
          </h2>
          <p className="hr-landing-packages-sub">
            גלו יעדים וחבילות מומלצות שנבחרו עבורכם מהמערכת.
          </p>
          <RandomPackages />
        </div>
      </section>
    </div>
  );
}

export default Main;
